var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3987",
    "data-name": "Group 3987",
    transform: "translate(-931 -11416.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3558",
    "data-name": "Group 3558"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_275",
    "data-name": "Ellipse 275",
    cx: 28,
    cy: 28,
    r: 28,
    transform: "translate(932 11417.001)",
    fill: "#333333",
    stroke: "#ee4e56",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3557",
    "data-name": "Group 3557"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_6124",
    "data-name": "Line 6124",
    y1: 20.707,
    transform: "translate(959.841 11435.415)",
    fill: "none",
    stroke: "#ee4e56",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4558",
    "data-name": "Path 4558",
    d: "M0,6.089,6.09,0l6.09,6.089",
    transform: "translate(953.751 11435.417)",
    fill: "none",
    stroke: "#ee4e56",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollIcon);
export default __webpack_public_path__ + "static/media/scroll-icon.d13f1c81b167ebc020bba42c6bd8d20e.svg";
export { ForwardRef as ReactComponent };